import { useContext } from 'react';

import { STATUSES } from '@openclassrooms/ui-web/learning-activities';
import { CHAPTER_STATUSES, STATUS_PROMOTION } from '../constants/LearningStatuses';
import CourseContext from '../contexts/courseContext';
import CourseChapterContext from '../contexts/courseChapterContext';

const { STATUS_IN_PROGRESS, STATUS_NOT_STARTED } = STATUSES;

interface Params {
  id: number;
  initialStatus?: (typeof CHAPTER_STATUSES)[number];
  isOnHomePage: boolean;
}

type LearningStatus = {
  status: (typeof CHAPTER_STATUSES)[number];
};

const useChapterLearningStatus = ({
  id,
  initialStatus = STATUS_NOT_STARTED,
  isOnHomePage,
}: Params): LearningStatus => {
  const { currentUser, course } = useContext(CourseContext);

  const { userIsFollowingCourse, learningActivityStatus: courseLearningStatus } = course || {};
  const { currentChapterId } = useContext(CourseChapterContext);

  const isUserFollowingCourse = Boolean(currentUser) && userIsFollowingCourse;

  if (!isUserFollowingCourse && isOnHomePage) {
    return { status: STATUS_PROMOTION };
  }

  const isChapterInProgress =
    courseLearningStatus === STATUS_IN_PROGRESS &&
    currentChapterId === id &&
    initialStatus === STATUS_NOT_STARTED;

  if (isChapterInProgress) {
    return { status: STATUS_IN_PROGRESS };
  }

  return { status: initialStatus };
};

export default useChapterLearningStatus;
